import { Tooltip } from 'antd'
import React from 'react'
import { Link } from 'react-router-dom'
import { useVenueNavTooltipOpen } from 'src/hooks/useVenueNavTooltipOpen'
import { closeVenueNavTooltips } from 'src/utils/venueNavTooltip'

/**
 * Venue top-nav link with a business-case tooltip (same pattern as Menu Builder).
 * One tip at a time; click and route change dismiss so tips do not leak.
 */
const VenueNavTooltipLink = ({
  to,
  tooltip,
  children,
  'data-testid': dataTestId,
}) => {
  const [open, onVisibleChange] = useVenueNavTooltipOpen(to)
  const link = (
    <Link to={to} data-testid={dataTestId} onClick={closeVenueNavTooltips}>
      {children}
    </Link>
  )
  if (!tooltip) return link

  return (
    <Tooltip
      title={tooltip}
      placement='bottom'
      visible={open}
      onVisibleChange={onVisibleChange}
      mouseEnterDelay={0.35}
      mouseLeaveDelay={0}
      destroyTooltipOnHide
      overlayClassName='venue-nav-tooltip'
      overlayStyle={{ pointerEvents: 'none' }}
      getPopupContainer={() => document.body}
    >
      {link}
    </Tooltip>
  )
}

export default VenueNavTooltipLink
